import React from "react";
import "./Onboarding.scss";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, Table, Button, Tooltip, Select, Spin, Empty } from "antd";
import Footer from "Common/Footer";
import { useNavigate } from "react-router-dom";

import {
  JobApplicationStatusEnum,
  JobApplicationStatusLabel,
  JobApplicationStatusText,
} from "Constants/Enums/JobApplicantStatusEnum";

import useOnboarding from "Hooks/AdminHooks/useOnboarding";

const Onboarding = () => {
  const navigate = useNavigate();
  const { Option } = Select;

  const {
    handleJobPostingChange,
    jobPostings,
    onboardingEmployees,
    selectedJobPostingId,
    loading,
  } = useOnboarding();

  const handleOnboarding = (empId) => {
    navigate(`/hiringOnboarding/${empId}`);
  };

  const columns = [
    {
      title: "Employee ID",
      dataIndex: "jobApplicantId",
      key: "jobApplicantId",
    },
    {
      title: "Name",
      key: "name",
      render: (_, record) => `${record.firstName} ${record.lastName}`,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (email) => (
        <Tooltip title={email}>
          {email?.length > 13 ? `${email.slice(0, 13)}...` : email}
        </Tooltip>
      ),
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => JobApplicationStatusLabel[status] || status,
    },
    {
      title: "Status Detail",
      dataIndex: "status",
      key: "statusDetail",
      render: (status) => (
        <span style={{ color: "#888" }}>
          {JobApplicationStatusText[status]}
        </span>
      ),
    },
    {
      title: "Onboard",
      key: "onboard",
      render: (_, record) => {
        const status = record.status;

        if (status === JobApplicationStatusEnum.DocumentRecieved) {
          return (
            <Tooltip title="Start Onboarding">
              <Button
                type="link"
                style={{ color: "#1890ff", fontWeight: 500 }}
                onClick={() => handleOnboarding(record.jobApplicantId)}
              >
                Onboarding
              </Button>
            </Tooltip>
          );
        }

        if (status === JobApplicationStatusEnum.OnboardingDone) {
          return (
            <Tooltip title="View Personal Info">
              <Button
                type="link"
                style={{ color: "green", fontWeight: 500 }}
                onClick={() =>
                  navigate(`/humanResource/${record.jobApplicantId}`)
                }
              >
                Personal Info
              </Button>
            </Tooltip>
          );
        }

        if (status === JobApplicationStatusEnum.Hired) {
          return (
            <Button type="link" disabled style={{ color: "gray" }}>
              Hired
            </Button>
          );
        }

        return (
          <Tooltip title="Waiting for document submission">
            <Button type="link" disabled>
              Onboarding
            </Button>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />

        <div className="body flex-grow-1 px-3">
          <Card
            title={`Onboarding (${onboardingEmployees?.length || 0})`}
            className="card-professional"
          >
            {/* FILTER */}
            <div className="row mb-3">
              <div className="col-md-6 d-flex align-items-center">
               <label
  style={{
    fontWeight: 500,
    marginRight: 10,
    minWidth: "60px",  
    whiteSpace: "nowrap",
  }}
>
  Job Title :
</label>

                <Select
                  showSearch
                  allowClear
                  optionFilterProp="children"
                  placeholder="Select a Job Title"
                  onChange={handleJobPostingChange}
                  value={
                    selectedJobPostingId
                      ? String(selectedJobPostingId)
                      : undefined
                  }
                  style={{ width: "100%" }}
                >
                  {jobPostings
                    ?.filter((e) => e.id != null)
                    ?.map((e) => (
                      <Option key={e.id} value={String(e.id)}>
                        {e.jobTitle}
                      </Option>
                    ))}
                </Select>
              </div>
            </div>

            {/* TABLE */}
            <Spin spinning={loading}>
              <Table
                className="custom-table"
                bordered
                columns={columns}
                dataSource={
                  Array.isArray(onboardingEmployees)
                    ? onboardingEmployees
                    : []
                }
                rowKey="jobApplicantId"
                pagination={{ pageSize: 6 }}
                locale={{
                  emptyText: (
                    <Empty description="No onboarding employees found" />
                  ),
                }}
              />
            </Spin>
          </Card>

          <Footer />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Onboarding;